import React, { useState } from "react";
import { isEmpty } from "lodash";
import { SliderPanel } from "../../../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import PayrollTransactionDetails from "../FundingSliders/PayrollTransactionDetails";
import { getFundingDetailByPlan } from "../../../../../services";
import { useEffect } from "react";
import PayrollFundingDetails from "../FundingSliders/PayrollFundingDetails";
import FundingDetailsCard from "./FundingDetailsCard";
import PayrollFundingConfirmation from "../FundingSliders/PayrollFundingConfirmation";

const columns = [
  {
    label: "Plan Name",
    className: "column-plan-name",
  },
  {
    label: "Plan ID",
    className: "column-plan-id",
  },
  {
    label: "Employees",
    className: "column-employee",
  },
  {
    label: "Total funding",
    className: "column-total-funding",
  },
  // {
  //   label: "Contribution details",
  //   className: "column-source-details",
  // },
  {
    label: "Source Info",
    className: "column-fund-status",
  },
];
const DisplayFundingPlanLevel = ({
  payrollId,
  setViewByDisabled,
  classificationType,
}) => {
  const [list, setList] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isFundModalOpen, setFundModalOpen] = useState(false);
  const [planId, setPlanId] = useState();
  const [data, setData] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [triggerSlider, setTriggerSlider] = useState(false);
  const [retriggerCount, setRetriggerCount] = useState(0);

  useEffect(() => {
    getFundingDetailByPlan(payrollId)
      .then((res) => {
        setList(res);
      })
      .catch((err) => {
        return err;
      });
  }, [payrollId, toggle]);

  const showPopup = (id) => {
    setPlanId(id);
    setModalOpen(true);
  };

  const showFundPopup = (data) => {
    setData(data);
    setFundModalOpen(!isFundModalOpen);
  };

  return (
    <div className="payroll-columns">
      {!isEmpty(list) ? (
        <>
          <div className="d-flex justify-content-space-between align-items-center align-self-center">
            {columns.map((item, index) => {
              return (
                <p className={`ft-12 grey-text ${item.className}`}>
                  {item.label}
                </p>
              );
            })}
          </div>
          <FundingDetailsCard
            list={list}
            showPopup={showPopup}
            showFundPopup={showFundPopup}
          />
        </>
      ) : (
        <div>No data</div>
      )}

      <SliderPanel
        isOpen={isModalOpen}
        size="30"
        showCancel={false}
        backdropClicked={() => setModalOpen(false)}
      >
        <div className="d-flex justify-content-between">
          <div className="ft-14 font-weight-500">Contribution details</div>
          <div>
            <FontAwesomeIcon
              icon={faTimes}
              size="18px"
              color="#828282"
              onClick={() => setModalOpen(false)}
              className="pointer"
            />
          </div>
        </div>
        <div className="border-top" />
        <PayrollTransactionDetails planId={planId} fileId={payrollId} />
      </SliderPanel>

      <SliderPanel
        isOpen={isFundModalOpen}
        size={(data && data.fundingStatus === 1) || triggerSlider ? "85" : "50"}
        showCancel={false}
        // backdropClicked={() => setFundModalOpen(!isFundModalOpen)}
      >
        {(data && data.fundingStatus === 1) || triggerSlider ? (
          <PayrollFundingDetails
            retrigger={false}
            triggerSlider={triggerSlider}
            setTriggerSlider={setTriggerSlider}
            isPlan={true}
            data={data}
            fileId={payrollId}
            toggle={toggle}
            setToggle={setToggle}
            isFundModalOpen={isFundModalOpen}
            setFundModalOpen={setFundModalOpen}
            setViewByDisabled={setViewByDisabled}
          />
        ) : (
          <PayrollFundingConfirmation
            triggerSlider={triggerSlider}
            setTriggerSlider={setTriggerSlider}
            data={data}
            retriggerCount={retriggerCount}
            setRetriggerCount={setRetriggerCount}
            toggle={toggle}
            fileId={payrollId}
            payrollId={payrollId}
            setViewByDisabled={setViewByDisabled}
            setToggle={setToggle}
            classificationType={classificationType}
            isFundModalOpen={isFundModalOpen}
            setFundModalOpen={setFundModalOpen}
          />
        )}
      </SliderPanel>
    </div>
  );
};

export default DisplayFundingPlanLevel;
